module.exports.textElement = require('./properties-text-element.tmpl.html');
module.exports.tickBoxElement = require('./properties-tick-box-element.tmpl.html');
module.exports.imageElement = require('./properties-image-element.tmpl.html');